// src/components/trending/TimeSelector.jsx

import React from 'react';
import '../../styles/trending/TrendingChart.css';

const TimeSelector = ({ selectedTime, onTimeChange }) => {
  const timeOptions = [
    { value: 'daily', label: 'Today' },
    { value: 'weekly', label: 'This Week' },
    { value: 'monthly', label: 'This Month' }
  ];
  
  const handleChange = (e) => {
    onTimeChange(e.target.value);
  };
  
  return (
    <div className="time-selector">
      <select 
        value={selectedTime} 
        onChange={handleChange}
        className="time-dropdown"
      >
        {timeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimeSelector;